import React from 'react'
import './about.css'

function About() {
    return (
        <div id='about' style={{display:'flex'}}>
            <div className='about-component'>
                <img src={require("../images/About.png")} />
                <div className="about">
                <h1 style={{fontSize:'40px',fontFamily: "Poppins" }}>About Us</h1>
                    <p>
                        We, as Aviation Consultants, have a large community of aviation representatives in and around
                        the world who assist with aircraft transition. Our representative community will assist you
                        with Physical inspection, Records review and scanning, Annual audit, Prepurchase inspection,
                        Borescope Inspection, Engine/Thrust reverser Inspection and Redelivery of aircraft and engines.</p>

                    <p>Our Mission is to provide Aviation Technical Asset Management Services and Solutions to Aircraft
                        Owners, Lessors, Airlines, Financial Institutions, Manufacturers, Private Operators, Insurance
                        Companies, and Part-out Vendors with accuracy, excellence, and trust.</p>

                    <p>Our core competency is quality control, and to that end, we have experts who have spent a
                        tremendous amount of time in various airlines in Quality Control and various CAMO departments.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default About
